// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compatWorkflow{
    position: relative;
    width: 90%;
    height: 100%;
    display: block;
}
.contentDragDropWorkflow{
    position: relative;
    width: 100%;
    height: 90%;
    display: flex;
}
.contentButtomsWorkflow{
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
}
/***************************************************************/
.contDragDrop{ display: flex;
     flex-direction: column;
     /* justify-content: center; */
     /* align-items: center; */
      padding: '20px' ;
      position: relative;
        width: 100%;
        height: 100%;
    }

.contFields{
    position: relative;
    display: flex;
    width: 100%;
    height: 90%;

}
.contSteps{ 
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 10%;
}
.contFieldResourses{
   flex: 1 1;
   border: 1px solid var(--border-table-color);
    padding: 10px;
    border-radius: var(--border-radios-small);
   
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}
.titleResources{
 font-size: var(--font-size-medium);
 color: var(--third-color);
 text-align: center;
}
.dragElement{
    margin: 10px;
    padding: 10px;
    border-radius: var(--border-radios-small);
    /* background-color: #e0e0e0; */
    color: var(--white-color);
    font-size: var(--font-size-medium);
    text-align: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1)
}
.contFieldMap{
    flex: 3 1;
    margin-left: 20px
}
.fieldMapElements{
    border: 1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        /* padding: 20px; */
        height: 100% !important; 
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: var(--white-color);
}
.hostFlowSelected{
    background-color: var(--hover-blue-list);
}
.hostFlowSelected:hover{
    background-color: var(--hover-blue-list);
}
.hostFlowSelected .field-larger{
    border: unset;
}
.hostFlowSelected .field-medium{
    border: unset;
}

.contElementItem{
    width: 70%;
    /* min-width: '400px', */
    height: 100%;
    padding: 15px;
    border-radius: var(--border-radios-small);
    cursor: pointer;
    text-align: center;
    background-color: var(--white-color);       
    position: relative;
    top:10%;
    color:var(--third-color);
    font-size: var(--font-size-medium);

}
.rowElementItem{
    display: flex;
    flex-direction: column;
    align-items: center; 
}`, "",{"version":3,"sources":["webpack://./src/components/workflow-components/WorkFlow.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA,gEAAgE;AAChE,eAAe,aAAa;KACvB,sBAAsB;KACtB,6BAA6B;KAC7B,yBAAyB;MACxB,gBAAgB;MAChB,kBAAkB;QAChB,WAAW;QACX,YAAY;IAChB;;AAEJ;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;;AAEf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,WAAW;AACf;AACA;GACG,SAAO;GACP,2CAA2C;IAC1C,aAAa;IACb,yCAAyC;;IAEzC,0CAA0C;AAC9C;AACA;CACC,kCAAkC;CAClC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,+BAA+B;IAC/B,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB;AACJ;AACA;IACI,SAAO;IACP;AACJ;AACA;IACI,2CAA2C;IAC3C,yCAAyC;IACzC,0CAA0C;QACtC,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,oCAAoC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,OAAO;IACP,wBAAwB;IACxB,kCAAkC;;AAEtC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":[".compatWorkflow{\r\n    position: relative;\r\n    width: 90%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n.contentDragDropWorkflow{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 90%;\r\n    display: flex;\r\n}\r\n.contentButtomsWorkflow{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n/***************************************************************/\r\n.contDragDrop{ display: flex;\r\n     flex-direction: column;\r\n     /* justify-content: center; */\r\n     /* align-items: center; */\r\n      padding: '20px' ;\r\n      position: relative;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n.contFields{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 90%;\r\n\r\n}\r\n.contSteps{ \r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 10%;\r\n}\r\n.contFieldResourses{\r\n   flex: 1;\r\n   border: 1px solid var(--border-table-color);\r\n    padding: 10px;\r\n    border-radius: var(--border-radios-small);\r\n   \r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n.titleResources{\r\n font-size: var(--font-size-medium);\r\n color: var(--third-color);\r\n text-align: center;\r\n}\r\n.dragElement{\r\n    margin: 10px;\r\n    padding: 10px;\r\n    border-radius: var(--border-radios-small);\r\n    /* background-color: #e0e0e0; */\r\n    color: var(--white-color);\r\n    font-size: var(--font-size-medium);\r\n    text-align: center;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1)\r\n}\r\n.contFieldMap{\r\n    flex: 3;\r\n    margin-left: 20px\r\n}\r\n.fieldMapElements{\r\n    border: 1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n        /* padding: 20px; */\r\n        height: 100% !important; \r\n        overflow-y: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        background-color: var(--white-color);\r\n}\r\n.hostFlowSelected{\r\n    background-color: var(--hover-blue-list);\r\n}\r\n.hostFlowSelected:hover{\r\n    background-color: var(--hover-blue-list);\r\n}\r\n.hostFlowSelected .field-larger{\r\n    border: unset;\r\n}\r\n.hostFlowSelected .field-medium{\r\n    border: unset;\r\n}\r\n\r\n.contElementItem{\r\n    width: 70%;\r\n    /* min-width: '400px', */\r\n    height: 100%;\r\n    padding: 15px;\r\n    border-radius: var(--border-radios-small);\r\n    cursor: pointer;\r\n    text-align: center;\r\n    background-color: var(--white-color);       \r\n    position: relative;\r\n    top:10%;\r\n    color:var(--third-color);\r\n    font-size: var(--font-size-medium);\r\n\r\n}\r\n.rowElementItem{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
